import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Link } from '@mui/material';
import CustomerPrice from '../../controls/CustomerPrice';
import { Customer, getShipToForNewOrders } from 'src/types/customer';
import { TopLevelItemSearch } from 'src/types/TopLevelSearch';
import imgNotAvail from 'src/assets/img_not_avail.png';

interface ItemSearchResultsProps {
  showItemResults: boolean;
  itemResults: TopLevelItemSearch;
  customerNumber: string;
  customer: Customer;
  handleLinkClick: (link: any) => void;
}

const ItemSearchResults: React.FC<ItemSearchResultsProps> = ({ showItemResults, itemResults, customerNumber, customer, handleLinkClick }) => {
  if (!showItemResults) return null;

  return (
    <>
      {itemResults.items?.length ? (
        <div className="content-search__modal__content__results-group content-search__modal__content__results__recent-items">
          <h2>Search Results</h2>
          {itemResults.items?.map((item: any, i: number) => {
            const linkTo = `/${customerNumber}/ItemDetail/${item.itemNumber}`;
            return (
              <Link
                key={i}
                className="content-search__modal__content__results__list-item withPricing"
                onClick={() => handleLinkClick({ item, linkTo })}
                target="_blank"
                component={RouterLink}
                to={linkTo}
                textAlign="center"
              >
                <div className="contentSearchImageDiv">
                  <div className="contentSearchImageDiv__img-group">
                    {item.images && item.images.length > 0 && (
                      <img
                        src={`https://www.bfgsupply.com/img/product/thumb/${item.images[0]}`}
                        width="40px"
                        height="40px"
                        onError={({ currentTarget }) => {
                          currentTarget.src = imgNotAvail;
                        }}
                      />
                    )}
                    <b>{item.itemNumber}</b>
                  </div>
                  <span className="contentSearchImageDiv__name">
                    <span className="contentSearchImageDiv__hyphen">-</span> {item.name}
                  </span>
                </div>
                <div className="customerPriceClass content-search__price-available">
                  <span className="content-search__available">({item.quantityAvailable})</span>
                  <CustomerPrice
                    load={true}
                    customerNumber={customerNumber}
                    warehouseCode={customer.warehouseCode}
                    itemNumber={item.itemNumber}
                    quantity={1}
                    defaultPrice={item.listPrice === 0 ? item.msrp : item.listPrice}
                    shipToNumber={getShipToForNewOrders(customer)}
                  />
                </div>
              </Link>
            );
          })}
        </div>
      ) : null}
    </>
  );
};

export default ItemSearchResults;
